var main =
webpackJsonp_name_([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Modules
var cache = {};

function importAll(r) {
  r.keys().forEach(function (key) {
    cache[key] = r(key);
  });
}

importAll(__webpack_require__(8));

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./dropdown/dropdown.js": 9,
	"./modal/modal.js": 10,
	"./page/page.js": 11,
	"./readmore/readmore.js": 12
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

// dropdown
(function () {
  'use strict';

  /**
   * Plugin name
   * @type {String}
   */

  var pluginName = 'dropdown';

  /**
   * Plugin default options
   * @type {Object}
   */
  var defaults = {
    outerClick: true,
    class: {
      base: 'dropdown',
      open: 'dropdown_open',
      disabled: 'dropdown_disabled'
    }
  };

  /**
   * Keyboard key codes
   * @type {Object}
   */
  var KEYCODE = {
    LEFT: 37,
    UP: 38,
    RIGHT: 39,
    DOWN: 40,
    ESCAPE: 27,
    TAB: 9
  };

  /**
   * Dropdown constructor
   * @constructor
   * @param {[jQuery]} element
   * @param {[Object]} options
   */
  function Plugin(element, options) {
    this.element = element;
    this._name = pluginName;
    this._defaults = defaults;

    this.$element = $(this.element);

    this.metadata = this.$element.data(this._name + '-' + 'options');

    this.options = $.extend({}, this._defaults, options, this.metadata);

    this.init();
  }

  $.extend(Plugin.prototype, {

    // Initialization logic
    init: function init() {
      this.buildCache();
      this.setA11yAttrs();

      if (this.isDisabled()) {
        this.setDisabledState();
      } else {
        this.bindEvents();
      }
    },

    // Remove plugin instance completely
    destroy: function destroy() {
      this.unbindEvents();
      this.$element.removeData();
    },

    // Cache DOM nodes for performance
    buildCache: function buildCache() {
      this.$trigger = this.$element.find('[data-dropdown-role="trigger"]');
      this.$dropMenu = this.$element.find('[data-dropdown-role="drop-menu"]');
      this.focusableElements = this.$dropMenu.find('*[tabindex], a[href]');
      this.selected = 0;
      this.triggerId = this._name + '_trigger_' + this.options.count;
    },

    // Bind events that trigger methods
    bindEvents: function bindEvents() {
      var plugin = this;

      plugin.$trigger.on('click' + '.' + plugin._name, function (event) {
        plugin.toggle.call(plugin, event);
      });

      plugin.$trigger.add(this.focusableElements).on('keydown' + '.' + plugin._name, function (event) {
        plugin.handleKeydown.call(plugin, event);
      });

      $(document).on('click' + '.' + plugin._name, function (event) {
        plugin.outerClickHandler.call(plugin, event);
      });
    },

    // Unbind events that trigger methods
    unbindEvents: function unbindEvents() {
      this.$element.off('.' + this._name);
    },

    open: function open() {
      if (!this.isOpen()) {
        this.$element.addClass(this.options.class.open).trigger('opened' + '.' + this._name);
        this.$trigger.attr('aria-expanded', true);
      }
    },

    close: function close() {
      this.$element.removeClass(this.options.class.open).trigger('closed' + '.' + this._name);
      this.$trigger.attr('aria-expanded', false);
    },

    // Return true when dropdown is open
    isOpen: function isOpen() {
      var open = false;

      if (this.$element.hasClass(this.options.class.open)) {
        open = true;
      }

      return open;
    },

    // Return true when dropdown disabled
    isDisabled: function isDisabled() {
      var disabled = false;

      if (this.$element.hasClass(this.options.class.disabled)) {
        disabled = true;
      }

      return disabled;
    },

    // Toggle dropdown
    toggle: function toggle() {
      if (this.isOpen()) {
        this.close();
      } else {
        this.open();
      }
    },

    // Click outside
    outerClickHandler: function outerClickHandler(event) {
      if (this.options.outerClick && this.isOpen()) {
        if (!$(event.target).closest(this.$element).length) {
          this.close();
        }
      }
    },

    // Keydown handler
    handleKeydown: function handleKeydown(event) {

      if (this.isDisabled()) {
        return;
      }

      switch (event.which) {

        case KEYCODE.ESCAPE:
          // this.close();

          console.log(this.$trigger);
          this.$trigger.focus();

          break;

        case KEYCODE.UP:
        case KEYCODE.LEFT:

          event.preventDefault();

          this.open();

          if (this.selected === 0) {
            this.selected = this.focusableElements.length - 1;
          } else {
            this.selected--;
          }
          break;

        case KEYCODE.DOWN:
        case KEYCODE.RIGHT:

          event.preventDefault();

          this.open();

          if (this.selected === this.focusableElements.length - 1) {
            this.selected = 0;
          } else {
            this.selected++;
          }

          break;
      }

      this.focusableElements[this.selected].focus();
    },

    setA11yAttrs: function setA11yAttrs() {
      this.$trigger.attr({
        'aria-haspopup': true,
        'aria-expanded': false,
        'id': this.triggerId
      });

      this.$dropMenu.attr({
        'aria-labelledby': this.triggerId
      });
    },

    setDisabledState: function setDisabledState() {
      this.$element.attr('aria-disabled', true);
      this.$trigger.attr('disabled', true);
    },

    // Call calback by name
    callback: function callback(name) {
      var cb = this.options[name];

      if (typeof cb === 'function') {
        cb.call(this.element);
      }
    }

  });

  $.fn[pluginName] = function (options) {
    return this.each(function (index) {
      options = $.extend(options, { 'count': index });

      if (!$.data(this, 'plugin_' + pluginName)) {
        $.data(this, 'plugin_' + pluginName, new Plugin(this, options));
      }
    });
  };
})();

$(function () {
  $('.dropdown').dropdown();
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

// Remodal
$(function () {
  $('[data-remodal-id]').remodal();
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

// page
(function () {
  var $page = $('.page');
  var $cover;

  $cover = $('<div class="page__cover">').appendTo($page);

  $cover.on('click', function (event) {
    event.preventDefault();

    if ($page.hasClass('page_mobile-menu_open')) {
      $page.removeClass('page_mobile-menu_open');
    }
  });
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

// readmore
(function () {

	$('.readmore').readmore({
		collapsedHeight: 200,
		moreLink: '<div class="readmore__button"><a href="#" class="dotted">Развернуть полное описание</a></div>',
		lessLink: '<div class="readmore__button"><a href="#" class="dotted">Свернуть описание</a></div>'
	});
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ })
],[7]);


// WEBPACK FOOTER //
// main.js